export function delay<T>(delayTime: number): Promise<T> {
  return new Promise((resolve) => {
    setTimeout(resolve, delayTime);
  });
}
